/**
 * Giving-record analytics. Sent to gtag when consent scripts have loaded;
 * always logged in development so mock sessions can be inspected.
 *
 * Never include charity names, notes, or other donor-entered text.
 */

import debug from '@/helpers/debug'

export const DONATION_ANALYTICS_EVENTS = {
  RecurringCreated: 'recurring_donation_created',
  RecurringUpdated: 'recurring_donation_updated',
  RecurringStopped: 'recurring_donation_stopped',
  RecurringRestarted: 'recurring_donation_restarted',
  RecurringDeleted: 'recurring_donation_deleted',
  RecurringOccurrenceSkipped: 'recurring_occurrence_skipped',
  DonationEdited: 'donation_edited',
} as const

export type DonationAnalyticsEvent =
  (typeof DONATION_ANALYTICS_EVENTS)[keyof typeof DONATION_ANALYTICS_EVENTS]

export type DonationAnalyticsParams = {
  frequency?: string
  end_condition?: string
  apply_scope?: string
  occurrence_count?: number
}

type GtagFn = (
  command: 'event',
  eventName: string,
  params?: Record<string, unknown>
) => void

function gtag(): GtagFn | undefined {
  if (typeof window === 'undefined') return undefined
  const candidate = (window as Window & { gtag?: GtagFn }).gtag
  return typeof candidate === 'function' ? candidate : undefined
}

export function trackDonationAnalytics(
  event: DonationAnalyticsEvent,
  params: DonationAnalyticsParams = {}
): void {
  const payload = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined)
  )
  debug('[donations analytics]', { event, ...payload })
  gtag()?.('event', event, payload)
}
